module.exports = __webpack_public_path__ + "50da3cc428ccd01e59a8972536e7ca6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/atlassian_2022_chart.png
// module id = 1636
// module chunks = 0